module.exports = __webpack_public_path__ + "img/84_13.d9ce6140.png";